import React from 'react'
import { Container, Typography, Box } from '@material-ui/core';
import LinkOffIcon from '@material-ui/icons/LinkOff';

function LinkExpired() {
 
    return (
        <Container maxWidth="sm">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="80vh"
          textAlign="center"
        >
          <LinkOffIcon style={{ fontSize: 80, color: '#f44336', marginBottom: 16 }} />
          <Typography variant="h4" gutterBottom>
            Link Expired
          </Typography>
          <Typography variant="body1" color="textSecondary">
          The link you’re trying to access has expired. Please look for a new one in your messages.
          </Typography>
        </Box>
      </Container>
      );
    };

export default LinkExpired